import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col full-width full-height references-compact-container min-height" }
const _hoisted_2 = { class: "references-header-container" }
const _hoisted_3 = { class: "references-index-container" }
const _hoisted_4 = { class: "references-article-container" }

import { ref } from 'vue'
import ReferencesIndex from 'components/references/ReferencesIndex.vue';
import ReferencesDetail from 'components/references/ReferencesDetail.vue';
import {ReferencesHistoryData} from 'src/services/ReferencesHistoryService';
import ReferencesHeader from 'components/references/ReferencesHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesPaneCompact',
  setup(__props) {

const referenceHistoryData = ref({});

function onArticleChanged(data : ReferencesHistoryData) {
    referenceHistoryData.value = data;
}

const referencesOption = ref('search');
function optionChanged(value) {
  referencesOption.value = value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ReferencesHeader, { onReferencesOptionChanged: optionChanged })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ReferencesIndex, {
        onArticleChanged: onArticleChanged,
        referencesOption: referencesOption.value
      }, null, 8, ["referencesOption"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ReferencesDetail, { "references-history-data": referenceHistoryData.value }, null, 8, ["references-history-data"])
    ])
  ]))
}
}

})